module.exports = __webpack_public_path__ + "img/discount.d6d26d75.svg";